export const SampleConstant = '{SampleConstant}';
export const GluuBaseUrl = '{GluuBaseUrl}';
export const SampleId = '{BaseAPIUrl}';
export const RequestId = '{RequestId}';
export const Inum = '{inum}';
export const AuthPath = 'oxauth/restv1/authorize';
export const LogoutPath = 'oxauth/restv1/end_session';
export const ScopeConstant = 'openid';
export const ResponseTypeConstant = 'code';
export const AcrValueConstant = 'basic';
export const BaseAPIUrl = '{BaseAPIUrl}';
export const ChallengeId = '{ChallengeId}';
export const ProfileId = '{ProfileId}';
export const Provider = '{Provider}';
export const BaseUrl = '{BaseUrl}';
export const WorkFlowId = '{WorkFlowId}';
